import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy } from "swiper"

Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs, Lazy])

"use strict";

document.addEventListener("DOMContentLoaded", () => {
	window.initSliders();
});

window.initSliders = () => {
	// main-slider
	let mainSliders = document.querySelectorAll('.main-slider');
	mainSliders.forEach((slider) => {
		var mainSliderSwiper = new Swiper(slider.querySelector('.main-slider__list'), {
			spaceBetween: 24,
			effect: 'fade',
			speed: 500,
			fadeEffect: {
			crossFade: true
			},
			autoplay: {
				delay: 5000,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
		});

		$('.main-slider').on('mouseenter', function(e){
			mainSliderSwiper.autoplay.stop();
		});
	
		$('.main-slider').on('mouseleave', function(e){
			mainSliderSwiper.autoplay.start();
		});

		if(slider.querySelectorAll('.main-slider__item').length <=1){
			slider.querySelector('.main-slider__btns').remove();
		}

	});

	// advantages-slider
	let advantagesSliders = document.querySelectorAll('.advantages');
	let advantagesSliderSwiper;
	
	advantagesSliders.forEach((slider) => {
		advantagesSliderSwiper = new Swiper(slider.querySelector('.advantages__list'), {
			slidesPerView: 1,
			spaceBetween: 0,
			autoplay: {
				delay: 8000,
			},
			slidesPerView: 'auto',
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
			},
			breakpoints: {
				1000: {
					slidesPerView: 'auto',
					spaceBetween: 60
				},
				720: {
					slidesPerView: 3,
					spaceBetween: 30
				},
				520: {
					slidesPerView: 2,
					spaceBetween: 16
				},
				420: {
					slidesPerView: 1,
					spaceBetween: 0
				}
			}
		});

		if($(window).width() >= 1000) {
			if(slider.querySelectorAll('.advantages__item').length <=4){
				slider.querySelector('.swiper-pagination').remove();
			}
	
		} else if($(window).width() >=720) {
			if(slider.querySelectorAll('.advantages__item').length <=3){
				slider.querySelector('.swiper-pagination').remove();
			}
		} else if($(window).width() >=520) {
			if(slider.querySelectorAll('.advantages__item').length <=2){
				slider.querySelector('.swiper-pagination').remove();
			}	
		} else if($(window).width() >=420) {
			if(slider.querySelectorAll('.advantages__item').length <=1){
				slider.querySelector('.swiper-pagination').remove();
			}
		} else if($(window).width() < 420) {
			if(slider.querySelectorAll('.advantages__item').length <=1){
				slider.querySelector('.swiper-pagination').remove();
			}
		}

	});

	// articles-slider
	let articlesSliders = document.querySelectorAll('.articles-slider');
	let articlesSliderSwiper;
	
	articlesSliders.forEach((slider) => {
		articlesSliderSwiper = new Swiper(slider.querySelector('.articles-slider__list'), {
			slidesPerView: 1,
			spaceBetween: 0,
			autoplay: {
				delay: 8000,
			},
			slidesPerView: 'auto',
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				1000: {
					slidesPerView: 4,
					spaceBetween: 26
				},
				520: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				420: {
					slidesPerView: 1,
					spaceBetween: 0
				}
			}
		});

		if($(window).width() >= 1000) {
			if(slider.querySelectorAll('.articles-slider__item').length <=4){
				slider.querySelector('.swiper-buttons').remove();
			}
	
		} else if($(window).width() >=520) {
			if(slider.querySelectorAll('.articles-slider__item').length <=2){
				slider.querySelector('.swiper-buttons').remove();
			}
		} else if($(window).width() >=420) {
			if(slider.querySelectorAll('.articles-slider__item').length <=1){
				slider.querySelector('.swiper-buttons').remove();
			}
		} else if($(window).width() < 420) {
			if(slider.querySelectorAll('.articles-slider__item').length <=1){
				slider.querySelector('.swiper-buttons').remove();
			}
		}

	});

	// product-gallery
	const mainCardSlider = document.querySelector('.product-slider__list');
	
	let thumbsSlider = document.querySelector('.product-thumb__list'),
		cardSliderThumbs;
		
	if (thumbsSlider)
		cardSliderThumbs = new Swiper(thumbsSlider, {
			direction: 'vertical',
			slidesPerView: 3,
			spaceBetween: 20,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});

	new Swiper(mainCardSlider, {
		effect: "slide",
		spaceBetween: 0,
		watchOverflow: true,
		navigation: {
			nextEl: '.product-thumb .swiper-button-next',
			prevEl: '.product-thumb .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
		},
		thumbs: {
			swiper: cardSliderThumbs
		},
		breakpoints: {
			520: {
				spaceBetween: 20,
			},
		}
	});


	let totalThumbs = $('.product-thumb__list .swiper-slide:not(.swiper-slide-duplicate)').length;

	if(totalThumbs <= 3) {
		$('.product-thumb .swiper-button-next, .product-thumb .swiper-button-prev').remove();
	}

	// products-slider
	let productsSliders = document.querySelectorAll('.products-slider');

	productsSliders.forEach((slider) => {
		var productsSliderSwiper = new Swiper(slider, {
			spaceBetween: 0,
			slidesPerView: 1,
			slidesPerGroup: 1,
			// loop: true,
			navigation: {
				nextEl: slider.previousElementSibling.querySelector('.swiper-button-next'),
				prevEl: slider.previousElementSibling.querySelector('.swiper-button-prev'),
			},
			autoplay: {
				delay: 5000,
			},
			breakpoints: {
				1160: {
					spaceBetween: 26,
					slidesPerView: 6,
					slidesPerGroup: 6,
				},
				720: {
					spaceBetween: 20,
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
				520: {
					spaceBetween: 16,
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
			}
		});

		$('.products-slider__list').mouseenter(function(){
			productsSliderSwiper.autoplay.stop();
		});
	
		$('.products-slider__list').mouseout(function(){
			productsSliderSwiper.autoplay.start();
		});

		if($(window).width() >= 1160) {
			if(slider.querySelectorAll('.products-slider__item').length <=6){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
	
		} else if($(window).width() >=720) {
			if(slider.querySelectorAll('.products-slider__item').length <=4){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
		} else if($(window).width() >=520) {
			if(slider.querySelectorAll('.products-slider__item').length <=2){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
		} else if($(window).width() < 520) {
			if(slider.querySelectorAll('.products-slider__item').length <=1){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
		}

	});

	// text-slider
	let textSliders = document.querySelectorAll('.text-page__slider');
	textSliders.forEach((slider) => {
		var textSliderSwiper = new Swiper(slider, {
			spaceBetween: 24,
			effect: 'fade',
			speed: 500,
			fadeEffect: {
			crossFade: true
			},
			autoplay: {
				delay: 8000,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
		});

		if(slider.querySelectorAll('.text-page__slider-item').length <=1){
			slider.querySelector('.swiper-buttons').remove();
		}

	});

	// about-slider
	let aboutSliders = document.querySelectorAll('.about-slider__list');
	aboutSliders.forEach((slider) => {
		var aboutSliderSwiper = new Swiper(slider, {
			spaceBetween: 24,
			effect: 'fade',
			speed: 500,
			fadeEffect: {
			crossFade: true
			},
			autoplay: {
				delay: 8000,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
		});

		if(slider.querySelectorAll('.about-slider__slide').length <=1){
			slider.querySelector('.swiper-buttons').remove();
		}

	});
	
}


